import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./Admin.css";
import AdminSidebar from "./components/AdminSidebar";
import AdminHeader from "./components/AdminHeader";
import axios from "axios";
import Loader from "../components/Loader";

const MailDetails = () => {
  const navigate = useNavigate();
  const { mailerId } = useParams();
  const [mailer, setMailer] = useState({});
  const [isLoading, setIsLoading] = useState(true);

   const [recipients, setRecipients] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 20;

  useEffect(() => {
    document.title = "Mail Details | BarterFunds";
    const token = window.sessionStorage.getItem("token");

    if (!token) {
      navigate("/login");
      return;
    }

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    axios
      .get(`${process.env.REACT_APP_API_URL}/mailer/${mailerId}`, { headers })
      .then((response) => {
        if (response.data.success) {
          setMailer(response.data.mailer);
          setRecipients(response.data.mailer.recipients || []);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          window.sessionStorage.clear();
          navigate("/login");
        }
        setIsLoading(false);
      });
  }, [navigate, mailerId]);

  const handleBack = () => {
    navigate(-1);
  };

 const getFileUrl = (filepath) => {
    if (filepath?.startsWith('uploads')) {
      return `${process.env.REACT_APP_API_URL}/${filepath}`;
    }
    return filepath;
  };


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };


  const filteredData = recipients.filter(
    (recipient) =>
      recipient.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      recipient.status.toLowerCase().includes(searchTerm.toLowerCase()) 
  );

  // Calculate pagination
  const totalItems = filteredData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  // const totalPages = 10;

  // Calculate the index range of items for the current page
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

  // Get the data for the current page
  const currentPageData = filteredData.slice(startIndex, endIndex);

  // Pagination handlers
  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };



  return (
    <div className="page-wrapper default-version">
      <AdminSidebar active={"mails"} />
      <AdminHeader />
      <>
        {isLoading ? (
          <Loader />
        ) : (
          <div className="body-wrapper">
            <div className="bodywrapper__inner">
              <div className="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
                <h6 className="page-title">
                  Mailer Details - {mailer.mailerId}
                </h6>
                <div className="d-flex flex-wrap justify-content-end gap-2 align-items-center breadcrumb-plugins">
                  <button
                    onClick={handleBack}
                    className="btn btn-sm btn-outline--primary"
                  >
                    <i className="la la-undo" /> Back
                  </button>
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  <div className="card mt-3">
                    
                    <div className="card-body">
                      <div className="row gy-3">
                        <div className="col-md-6">
                          <strong>Mail ID:</strong>
                          <p>{mailer.mailerId}</p>
                        </div>

                        <div className="col-md-6">
                          <strong>User Group:</strong>
                          <p>{mailer.userGroup || "—"}</p>
                        </div>

                        <div className="col-md-6">
                          <strong>Subject:</strong>
                          <p>{mailer.subject}</p>
                        </div>

                        <div className="col-md-6">
                          <strong>Status:</strong>
                          <br />
                          <span
                            className={`badge ${
                              mailer.status === "success"
                                ? "badge--success"
                                : mailer.status === "failed"
                                ? "badge--danger"
                                : "badge--warning"
                            }`}
                          >
                            {mailer.status === "success"
                              ? "Sent"
                              : mailer.status === "failed"
                              ? "Failed"
                              : "Pending"}
                          </span>
                        </div>

                        <div className="col-md-12">
                          <strong>Message:</strong>
                          <div className="border p-3 rounded">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: mailer.message,
                              }}
                            />
                          </div>
                        </div>

                       

                        <div className="col-md-6">
                          <strong>Attachments:</strong>
                          <ul>
                            {mailer.attachments?.length > 0 ? (
                              mailer.attachments.map((file, i) => (
                                <li key={i}>
                                 
                                  <a href={getFileUrl(file)} target='_blank' rel="noreferrer">Attachment {i + 1}</a>
                                </li>
                              ))
                            ) : (
                              <li>—</li>
                            )}
                          </ul>
                        </div>

                        <div className="col-md-6">
                          <strong>Scheduled:</strong>
                          <p>{mailer.isScheduled ? "Yes" : "No"}</p>
                        </div>

                        {mailer.isScheduled && (
                          <div className="col-md-6">
                            <strong>Schedule Time:</strong>
                            <p>
                              {new Date(mailer.scheduleTime).toLocaleString()}
                            </p>
                          </div>
                        )}

                        <div className="col-md-6">
                          <strong>Template:</strong>
                          <p>{mailer.templateId?.title || "No template used"}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Recipients */}
                  <div className="card mt-4">
                      <div className="d-flex justify-content-between align-items-center mb-4">
                  <h6 className="page-title">Recipients: {mailer.recipients.length}</h6>
                
                  <div className="d-flex flex-wrap justify-content-end align-items-center breadcrumb-plugins">
                  <div className="input-group w-auto flex-fill">
                        <input
                          type="search"
                          name="search"
                          className="form-control bg--white text-white"
                          placeholder="Search..."
                          value={searchTerm}
                          onChange={handleSearchChange}
                        />
                        <button className="btn btn--primary" type="submit">
                          <i className="la la-search" />
                        </button>
                      </div>
                  </div>
                </div>
                
                

                    <div className="card-body table-responsive p-0">
                      <table className="table table--light style--two">
                        <thead>
                          <tr>
                            {/* <th>#</th> */}
                            <th>Email</th>
                            {/* <th>First Name</th> */}
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentPageData && currentPageData.length > 0 ? (
                            currentPageData.map((rec, index) => (
                              <tr key={index}>
                                {/* <td>{index + 1}</td> */}
                                <td>{rec.email}</td>
                                {/* <td>{rec.firstname || "—"}</td> */}
                                <td>
                                  <span
                                    className={`badge ${
                                      rec.status === "sent"
                                        ? "badge--success"
                                        : rec.status === "failed"
                                        ? "badge--danger"
                                        : "badge--warning"
                                    }`}
                                  >
                                    {rec.status === "sent"
                              ? "Sent"
                              : rec.status === "failed"
                              ? "Failed"
                              : "Pending"}
                                  </span>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                No recipients found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                       {currentPageData.length === 0 ? (
                  <p></p>
                ) : (
                  <div className="card-footer py-4">
                    <nav>
                      <ul className="pagination">
                        {/* Previous Button */}
                        <li
                          className="page-item"
                          onClick={() => goToPage(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          <button className="page-link" disabled={currentPage === 1}>
                            «
                          </button>
                        </li>
                
                        {/* First Page */}
                        {currentPage > 2 && (
                          <li className="page-item">
                            <button className="page-link" onClick={() => goToPage(1)}>
                              1
                            </button>
                          </li>
                        )}
                
                        {/* Ellipsis for pages before current */}
                        {currentPage > 3 && (
                          <li className="page-item disabled">
                            <button className="page-link">...</button>
                          </li>
                        )}
                
                        {/* Dynamic page links around current page */}
                        {[...Array(totalPages)]
                          .map((_, index) => index + 1)
                          .filter(
                            (page) =>
                              page === currentPage ||
                              page === currentPage - 1 ||
                              page === currentPage + 1
                          )
                          .map((page) => (
                            <li
                              key={page}
                              className={`page-item ${
                                page === currentPage ? "active" : ""
                              }`}
                            >
                              <button className="page-link" onClick={() => goToPage(page)}>
                                {page}
                              </button>
                            </li>
                          ))}
                
                        {/* Ellipsis for pages after current */}
                        {currentPage < totalPages - 2 && (
                          <li className="page-item disabled">
                            <button className="page-link">...</button>
                          </li>
                        )}
                
                        {/* Last Page */}
                        {currentPage < totalPages - 1 && (
                          <li className="page-item">
                            <button className="page-link" onClick={() => goToPage(totalPages)}>
                              {totalPages}
                            </button>
                          </li>
                        )}
                
                        {/* Next Button */}
                        <li
                          className="page-item"
                          onClick={() => goToPage(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          <button
                            className="page-link"
                            disabled={currentPage === totalPages}
                          >
                            »
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                )}

                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    </div>
  );
};

export default MailDetails;
